/* ============================================
   ON-HOOK — Premium Interactions
   Fade-up reveal, counters, FAQ, sticky CTA,
   smooth scroll, marquee loop.
   ============================================ */

(function() {
  'use strict';

  /* --- 1. Scroll Reveal (supports .oh-reveal and .oh-animate) --- */
  function initReveal() {
    var els = document.querySelectorAll('.oh-reveal, .oh-animate');
    if (!els.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -60px 0px'
    });

    els.forEach(function(el) { observer.observe(el); });
  }

  /* --- 2. Animated Counters --- */
  function initCounters() {
    var counters = document.querySelectorAll('[data-oh-counter]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(function(el) { observer.observe(el); });
  }

  function animateCounter(el) {
    var target = el.getAttribute('data-oh-counter');
    var suffix = el.getAttribute('data-oh-suffix') || '';
    var prefix = el.getAttribute('data-oh-prefix') || '';
    var isFloat = target.indexOf('.') !== -1;
    var end = parseFloat(target);
    var duration = 2000;
    var start = performance.now();

    function step(now) {
      var progress = Math.min((now - start) / duration, 1);
      /* ease-out-cubic */
      var ease = 1 - Math.pow(1 - progress, 3);
      var current = ease * end;
      el.textContent = prefix + (isFloat ? current.toFixed(1) : Math.floor(current)) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* --- 3. FAQ Accordion --- */
  function initFAQ() {
    document.querySelectorAll('.oh-faq__question').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.oh-faq__item');
        var list = item.closest('.oh-faq__list');
        var isOpen = item.classList.contains('is-open');

        /* Close all other items */
        if (list) {
          list.querySelectorAll('.oh-faq__item.is-open').forEach(function(open) {
            if (open !== item) open.classList.remove('is-open');
          });
        }

        item.classList.toggle('is-open', !isOpen);
      });
    });
  }

  /* --- 4. Sticky Mobile CTA --- */
  function initStickyCTA() {
    var sticky = document.querySelector('.oh-sticky');
    if (!sticky) return;

    var hero = document.querySelector('.oh-vhero') || document.querySelector('.oh-hero');
    if (!hero) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });

    observer.observe(hero);
  }

  /* --- 5. Smooth Scroll --- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(a) {
      a.addEventListener('click', function(e) {
        var href = a.getAttribute('href');
        if (href === '#') return;
        var target = document.querySelector(href);
        if (!target) return;

        e.preventDefault();
        var startY = window.scrollY;
        var endY = target.getBoundingClientRect().top + startY - 80;
        var distance = endY - startY;
        var duration = 800;
        var startTime = null;

        function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        }

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          var progress = Math.min((timestamp - startTime) / duration, 1);
          window.scrollTo(0, startY + distance * easeInOutCubic(progress));
          if (progress < 1) requestAnimationFrame(step);
        }

        requestAnimationFrame(step);
      });
    });
  }

  /* --- 6. Marquee Seamless Loop --- */
  function initMarquee() {
    document.querySelectorAll('.oh-marquee__track').forEach(function(track) {
      if (track.dataset.ohInit) return;
      track.dataset.ohInit = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* --- 7. Hotspots — tooltip outside rotated container --- */
  function initHotspots() {
    document.querySelectorAll('.oh-hotspots-wrap').forEach(function(wrap) {
      var tip = wrap.querySelector('[data-oh-tip]');
      var hotspots = wrap.querySelectorAll('.oh-hotspot');
      if (!tip || !hotspots.length) return;

      function showTip(hotspot) {
        var heading = hotspot.getAttribute('data-heading') || '';
        var text = hotspot.getAttribute('data-text') || '';
        var image = hotspot.getAttribute('data-image') || '';

        var html = '';
        if (image) html += '<img class="oh-hotspot-tip__img" src="' + image + '" alt="">';
        if (heading) html += '<h4 class="oh-hotspot-tip__title">' + heading + '</h4>';
        if (text) html += '<p class="oh-hotspot-tip__text">' + text + '</p>';
        tip.innerHTML = html;
        tip.style.display = 'block';
        tip.style.opacity = '1';

        /* Position: get dot's position relative to the wrap container */
        var dot = hotspot.querySelector('.oh-hotspot__dot');
        var dotRect = dot.getBoundingClientRect();
        var wrapRect = wrap.getBoundingClientRect();

        var tipW = tip.offsetWidth;
        var tipH = tip.offsetHeight;

        var left = (dotRect.left + dotRect.width / 2) - wrapRect.left - tipW / 2;
        var top = (dotRect.top - wrapRect.top) - tipH - 12;

        /* Clamp horizontally */
        if (left < 0) left = 0;
        if (left + tipW > wrapRect.width) left = wrapRect.width - tipW;

        /* If no room above, show below */
        if (top < 0) top = (dotRect.bottom - wrapRect.top) + 12;

        tip.style.left = left + 'px';
        tip.style.top = top + 'px';
      }

      function hideTip() {
        tip.style.display = 'none';
        tip.style.opacity = '0';
        hotspots.forEach(function(h) { h.classList.remove('is-active'); });
      }

      hotspots.forEach(function(hotspot) {
        /* Desktop hover */
        hotspot.addEventListener('mouseenter', function() { showTip(hotspot); });
        hotspot.addEventListener('mouseleave', function() { hideTip(); });

        /* Mobile tap */
        hotspot.querySelector('.oh-hotspot__dot').addEventListener('click', function(e) {
          e.stopPropagation();
          var wasActive = hotspot.classList.contains('is-active');
          hideTip();
          if (!wasActive) {
            hotspot.classList.add('is-active');
            showTip(hotspot);
          }
        });
      });

      document.addEventListener('click', function() { hideTip(); });
    });
  }

  /* --- 8. Product Media Thumbnails --- */
  function initMediaThumbs() {
    document.querySelectorAll('[data-oh-media]').forEach(function(gallery) {
      var main = gallery.querySelector('[data-oh-media-main]');
      var thumbs = gallery.querySelectorAll('.oh-media__thumb');
      if (!main || !thumbs.length) return;

      /* Preload + decode large versions so click swap is instant */
      thumbs.forEach(function(thumb) {
        var thumbImg = thumb.querySelector('.oh-media__thumb-img');
        if (!thumbImg) return;
        var largeSrc = thumbImg.src.replace(/width=\d+/, 'width=1200');
        thumb.dataset.largeSrc = largeSrc;
        var pre = new Image();
        pre.src = largeSrc;
        if (pre.decode) pre.decode().catch(function(){});
      });

      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          thumbs.forEach(function(t) { t.classList.remove('oh-media__thumb--active'); });
          thumb.classList.add('oh-media__thumb--active');

          var mainImg = main.querySelector('.oh-media__img');
          if (mainImg && thumb.dataset.largeSrc) {
            mainImg.src = thumb.dataset.largeSrc;
            mainImg.srcset = '';
          }
        });
      });
    });
  }

  /* --- 8c. Add-on upsell (cart drawer, /cart page, homepage grid) ---
     One delegated listener on document, because the cart drawer replaces its
     own innerHTML on every cart change — anything bound directly to the
     buttons would be thrown away on the first add.
  */
  function initUpsell() {
    if (document.body.dataset.ohUpsellBound) return;
    document.body.dataset.ohUpsellBound = '1';

    document.addEventListener('click', function(evt) {
      var btn = evt.target.closest('[data-oh-upsell-add]');
      if (!btn || btn.disabled) return;
      evt.preventDefault();

      var wrap = btn.closest('[data-oh-upsell]');
      var context = wrap ? wrap.getAttribute('data-oh-upsell') : 'default';
      var status = wrap ? wrap.querySelector('[data-oh-upsell-status]') : null;
      var label = btn.querySelector('.oh-upsell__add-label');
      var drawer = document.querySelector('cart-drawer');
      /* On /cart the page itself is the cart — reload instead of popping the
         drawer over it. Everywhere else the drawer is the feedback. */
      var useDrawer = drawer && context !== 'cart';

      /* Labels come from theme settings via data-* so they translate with
         the storefront locale instead of being hardcoded English here. */
      var strings = {
        adding: (wrap && wrap.dataset.addingLabel) || 'Adding…',
        added: (wrap && wrap.dataset.addedLabel) || 'Added ✓',
        error: (wrap && wrap.dataset.errorLabel) || 'Could not add this item.'
      };

      if (status) status.textContent = '';
      btn.disabled = true;
      if (label) label.textContent = strings.adding;

      var body = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
      if (useDrawer) {
        body.sections = 'cart-drawer,cart-icon-bubble';
        body.sections_url = window.location.pathname;
      } else {
        body.sections = 'cart-icon-bubble';
        body.sections_url = window.location.pathname;
      }

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function(res) {
          return res.json().then(function(data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function(result) {
          if (!result.ok) {
            throw new Error(result.data.description || result.data.message || strings.error);
          }

          if (context === 'cart') {
            window.location.reload();
            return;
          }

          var sections = result.data.sections || {};

          if (useDrawer && sections['cart-drawer']) {
            /* Repaints the drawer (which re-renders this upsell list without
               the item just added) and opens it. */
            drawer.renderContents(result.data);
          } else if (sections['cart-icon-bubble']) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble) {
              var parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
              var fresh = parsed.querySelector('.shopify-section');
              if (fresh) bubble.innerHTML = fresh.innerHTML;
            }
          }

          btn.classList.add('is-added');
          if (label) label.textContent = strings.added;
          setTimeout(function() {
            btn.disabled = false;
            btn.classList.remove('is-added');
            if (label) label.textContent = btn.dataset.defaultLabel;
          }, 2500);
        })
        .catch(function(err) {
          btn.disabled = false;
          if (label) label.textContent = btn.dataset.defaultLabel;
          if (status) status.textContent = err.message || strings.error;
        });
    });
  }

  /* --- 8b. Variant Sync (subscribes to Dawn's pubsub) ---
     Dawn's <product-info> auto-handles price, inventory, ATC button via
     its updateMedia / updateOptionValues fetch flow. Two things it CAN'T
     handle here:
       1. The custom <div data-oh-media> gallery — Dawn looks for
          <media-gallery><ul><li data-media-id> — different structure.
       2. The "Buy Now — Skip Cart" form's hidden variant ID input —
          Dawn only updates inputs inside #product-form-{section}.
     We bridge both by subscribing to Dawn's variantChange event.
  */
  function initVariantSync() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    /* Capture the original ATC text per section so we can restore it after
       Dawn's toggleSubmitButton hard-codes window.variantStrings.addToCart. */
    document.querySelectorAll('product-info').forEach(function(host) {
      var section = host.dataset.section;
      if (!section) return;
      var btn = host.querySelector('#ProductSubmitButton-' + section);
      var span = btn && btn.querySelector('span');
      if (span && !btn.dataset.defaultText) {
        btn.dataset.defaultText = span.textContent.trim();
      }
    });

    subscribe(PUB_SUB_EVENTS.variantChange, function(payload) {
      var data = payload && payload.data;
      if (!data) return;
      var sectionId = data.sectionId;
      var variant = data.variant;
      if (!sectionId || !variant) return;

      var host = document.querySelector('product-info[data-section="' + sectionId + '"]');
      if (!host) return;

      /* Sync oh-media gallery: reuse the thumb-click swap (preloaded image). */
      if (variant.featured_media && variant.featured_media.id) {
        var thumb = host.querySelector('.oh-media__thumb[data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) thumb.click();
      }

      /* Sync any non-Dawn form (e.g. the Buy Now — Skip Cart forms in
         oh-buy and oh-product). Dawn only updates inputs inside its
         main #product-form-{section}. We mirror variant id + disabled
         state into every other product form within this product-info. */
      host.querySelectorAll('form').forEach(function(form) {
        /* Use getAttribute — form.id returns the <input name="id"> element
           via HTMLFormElement's named-element collection, not the id string. */
        var formId = form.getAttribute('id') || '';
        if (formId.indexOf('product-form-') === 0) return;
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = variant.id;
        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = !variant.available;
      });

      /* Restore the custom ATC text — Dawn just overwrote it with the
         generic locale string. Only for available variants; sold-out text
         stays as Dawn set it. */
      if (variant.available) {
        var atcBtn = host.querySelector('#ProductSubmitButton-' + sectionId);
        var atcSpan = atcBtn && atcBtn.querySelector('span');
        if (atcSpan && atcBtn.dataset.defaultText) {
          atcSpan.textContent = atcBtn.dataset.defaultText;
        }
      }
    });
  }

  /* --- 8c. Inline Countdown (promo bar + bundle section) ---
     Renders d/h/m/s digits inside [data-oh-countdown-inline][data-time].
     Dispatches "oh-countdown:expired" event on the host when deadline hits. */
  function initInlineCountdown() {
    document.querySelectorAll('[data-oh-countdown-inline][data-time]').forEach(function(el) {
      if (el.dataset.ohCdInit) return;
      el.dataset.ohCdInit = '1';

      var raw = el.dataset.time.trim();
      if (!raw) return;
      var endTs = Date.parse(raw.replace(' ', 'T'));
      if (isNaN(endTs)) return;

      var dEl = el.querySelector('[data-d]');
      var hEl = el.querySelector('[data-h]');
      var mEl = el.querySelector('[data-m]');
      var sEl = el.querySelector('[data-s]');
      if (!dEl || !hEl || !mEl || !sEl) return;

      function pad(n) { return n < 10 ? '0' + n : '' + n; }

      function tick() {
        var diff = endTs - Date.now();
        if (diff <= 0) {
          dEl.textContent = hEl.textContent = mEl.textContent = sEl.textContent = '00';
          el.dispatchEvent(new CustomEvent('oh-countdown:expired', { bubbles: true }));
          clearInterval(timer);
          return;
        }
        dEl.textContent = pad(Math.floor(diff / 86400000));
        hEl.textContent = pad(Math.floor(diff / 3600000) % 24);
        mEl.textContent = pad(Math.floor(diff / 60000) % 60);
        sEl.textContent = pad(Math.floor(diff / 1000) % 60);
      }

      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  /* --- 8d. Promo Bar — auto-hide on countdown expiry --- */
  function initPromoBar() {
    document.querySelectorAll('oh-promo-bar').forEach(function(bar) {
      bar.addEventListener('oh-countdown:expired', function() {
        bar.style.transition = 'opacity 0.3s, max-height 0.3s';
        bar.style.opacity = '0';
        bar.style.maxHeight = '0';
        setTimeout(function() { bar.remove(); }, 350);
      });
    });
  }

  /* --- 9. Product Page Tabs + Quantity --- */
  function initProductTabs() {
    document.querySelectorAll('.oh-product__tab-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var tab = btn.closest('.oh-product__tab');
        tab.classList.toggle('is-open');
      });
    });
  }

  function initProductQty() {
    document.querySelectorAll('.oh-product__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.closest('.oh-product__qty-controls').querySelector('.oh-product__qty-input');
        var val = parseInt(input.value) || 1;
        if (btn.getAttribute('data-action') === 'minus') {
          input.value = Math.max(1, val - 1);
        } else {
          input.value = val + 1;
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* --- Init --- */
  function init() {
    initReveal();
    initCounters();
    initFAQ();
    initStickyCTA();
    initSmoothScroll();
    initMarquee();
    initHotspots();
    initMediaThumbs();
    initVariantSync();
    initInlineCountdown();
    initPromoBar();
    initProductTabs();
    initProductQty();
    initUpsell();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify section editor support */
  document.addEventListener('shopify:section:load', init);
})();

/* ── Inventory progress bar custom element ────────────── */
if (!customElements.get('oh-progress-bar')) {
  class OhProgressBar extends HTMLElement {
    connectedCallback() {
      this._update(this.dataset.value, this.dataset.max);
    }
    _update(value, max) {
      const pct = Math.min(100, Math.max(0, (parseInt(value) / parseInt(max)) * 100));
      this.style.setProperty('--oh-inv-percent', `${pct}%`);
    }
  }
  customElements.define('oh-progress-bar', OhProgressBar);
}
